import { useMutation } from 'react-query';
import { login as loginRequest, forgotPassword as forgotPasswordRequest, resetPassword as resetPasswordRequest } from '@/services/authService';
import { clearAuthToken, setAuthToken } from '@/auth/token';

export function useLogin() {
  return useMutation({
    mutationFn: async (payload: { email: string; password: string }) => {
      const res = await loginRequest(payload);
      return res.data;
    },
    onSuccess: (data) => {
      setAuthToken(data.token);
    },
  });
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: async (payload: { email: string }) => {
      const res = await forgotPasswordRequest(payload);
      return res.data;
    },
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: async (payload: { token: string; password: string }) => {
      const res = await resetPasswordRequest(payload);
      return res.data;
    },
  });
}

export function logout() {
  clearAuthToken();
}
